import { useEffect } from 'react'

import classNames from 'classnames'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const s3BaseUrl = process.env.REACT_APP_URL_S3 || ''

export default function PaymentCicloBonoReady() {
  const { token } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)
  const option = searchParams.get('option')

  const isApp = option === 'APP'
  const isEmail = option === 'RETIRA'

  useEffect(() => {
    if (!token) {
      navigate('/')
    }
  }, [token, navigate])

  const containerClassName = classNames(
    'min-h-screen',
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'px-4',
    'py-8',
    'sm:px-6',
    'lg:px-8',
    'bg-gradient-to-br',
    'from-grey-500',
    'via-white',
    'to-green-700',
  )

  const cardClassName = classNames(
    'w-full',
    'max-w-md',
    'sm:max-w-lg',
    'bg-white',
    'rounded-3xl',
    'shadow-lg',
    'p-6',
    'sm:p-10',
    'text-center',
    'space-y-6',
  )

  const titleClassName = classNames(
    'text-2xl',
    'sm:text-3xl',
    'font-bold',
    'text-black',
  )

  const subtitleClassName = classNames(
    'text-base',
    'sm:text-lg',
    'text-grey-800',
    'leading-relaxed',
  )

  const iconContainerClassName = classNames(
    'w-20',
    'h-20',
    'sm:w-24',
    'sm:h-24',
    'mx-auto',
    'rounded-full',
    'flex',
    'items-center',
    'justify-center',
    'mb-4',
  )

  return (
    <div className={containerClassName}>
      <div className={cardClassName}>
        <div
          className={`${iconContainerClassName} bg-gradient-to-br from-blue-800 to-green-800`}
        >
          <svg
            className="w-10 h-10 sm:w-12 sm:h-12 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h2 className={titleClassName}>
          {isApp
            ? '¡Acumulamos tu CicloBono!'
            : isEmail
            ? '¡Gestionamos tu CicloBono!'
            : '¡Respuesta enviada!'}
        </h2>

        <p className={subtitleClassName}>
          {isApp
            ? 'Tu ahorro generado estará disponible en la nueva sección "Monedero" de la app. ¡Muy pronto te avisaremos para que puedas canjearlo! Sigue acumulando saldo registrando todos tus km en coche compartido.'
            : isEmail
            ? 'En las próximas semanas recibirás un email con el link para canjear tu CicloBono por tarjetas regalo de tus marcas preferidas.'
            : 'Hemos registrado tu respuesta correctamente. Gracias por tu participación.'}
        </p>

        <div className="bg-green-700 rounded-2xl p-4 sm:p-6 mt-4">
          <p className="text-sm sm:text-base text-black">
            Si tienes alguna duda o necesitas ayuda, puedes contactarnos en{' '}
            <a
              href="mailto:soporte@ciclogreen.com"
              className="text-blue-800 font-semibold hover:underline"
            >
              soporte@ciclogreen.com
            </a>
          </p>
        </div>

        <div className="pt-6">
          <img
            src={`${s3BaseUrl}/images/logo_10years.png`}
            alt="Ciclogreen"
            className="h-12 sm:h-14 mx-auto"
          />
        </div>
      </div>
    </div>
  )
}
